/**
 * Typy elementów komponentu `w-button`
 *
 * @export
 * @enum {number}
 */
export enum ButtonElementType {
  BUTTON = 'button',
  LINK = 'a',
  ROUTER_LINK = 'router-link'
}
